import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useMemo, useState } from 'react';
import { Icon, Row, Col } from 'panamera-react-ui';
import cx from 'classnames';
import withConfig from "../../ComponentDependency/withConfig";
import { FormattedMessage as Translation } from 'react-intl';
import UserSession from "../../Utils/UserSession";
var css = {
  "bcWidget": "oalp-dRPrn",
  "topContent": "oalp-qfqt7",
  "imageWrapper": "oalp-srf4e",
  "image": "oalp-2LmOv",
  "carDetails": "oalp-2kMAE",
  "textContent": "oalp-1irfr",
  "centerDetails": "oalp-3rrgM",
  "buttonWrapper": "oalp-3erj2",
  "button": "oalp-1i3uA",
  "body1": "oalp-3G30U",
  "footnote": "oalp-VtLQl",
  "flex": "oalp-2d6Qf",
  "marginLeft2": "oalp-2lPaP",
  "marginTop2": "oalp-2t6BK",
  "ellipses": "oalp-1d_Cd"
};
import { populateStringTemplate } from "../../Utils/TextHelper";
import CTA from "../../Components/CTA/CTA";
import { getFormatedTimeSlot } from "./renderHelpers";
import ImageWrapper from "../../Components/ImageWrapper/ImageWrapper";
import DependencyManager from "../../DependencyManager";
export var BookingConfirmedWidget = function BookingConfirmedWidget(_ref) {
  var data = _ref.data,
    style = _ref.metadata.style,
    name = _ref.name,
    track = _ref.track,
    locationId = _ref.locationId,
    config = _ref.config,
    userIsLogged = _ref.userIsLogged,
    disclaimer = _ref.disclaimer;
  var _a;
  var image = data.image,
    _data$cta$buttons = data.cta.buttons,
    buttons = _data$cta$buttons === void 0 ? [] : _data$cta$buttons;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    appointmentDetails = _useState2[0],
    setAppointmentDetails = _useState2[1];
  var PanameraConstants = DependencyManager.getDependency('constants');
  var IS_DEKSTOP = PanameraConstants.platform === 'desktop';
  var isL2PTracker = !!config.get('isL2PTracker');
  useEffect(function () {
    var details = UserSession.getAppointmentDetails();
    if (details) {
      setAppointmentDetails(details);
    }
  }, []);
  var _appointmentDetails$v = appointmentDetails.vehicle,
    _appointmentDetails$v2 = _appointmentDetails$v === void 0 ? {} : _appointmentDetails$v,
    _appointmentDetails$v3 = _appointmentDetails$v2.make,
    make = _appointmentDetails$v3 === void 0 ? '' : _appointmentDetails$v3,
    _appointmentDetails$v4 = _appointmentDetails$v2.model,
    model = _appointmentDetails$v4 === void 0 ? '' : _appointmentDetails$v4,
    _appointmentDetails$v5 = _appointmentDetails$v2.year,
    year = _appointmentDetails$v5 === void 0 ? '' : _appointmentDetails$v5,
    _appointmentDetails$c = appointmentDetails.centre,
    _appointmentDetails$c2 = _appointmentDetails$c === void 0 ? {} : _appointmentDetails$c,
    _appointmentDetails$c3 = _appointmentDetails$c2.address2,
    centerName = _appointmentDetails$c3 === void 0 ? '' : _appointmentDetails$c3,
    slotDetails = appointmentDetails.slotDetails,
    bookingId = appointmentDetails.bookingId;
  var isglobalTimeRequired = config.get('isLocalDateRequired') || ((_a = disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.config) === null || _a === void 0 ? void 0 : _a.is_24_format_enabled);
  var siteCode = config.get('siteCode');
  var _ref2 = slotDetails ? getFormatedTimeSlot(slotDetails, siteCode, isglobalTimeRequired) : {},
    _ref2$date = _ref2.date,
    date = _ref2$date === void 0 ? null : _ref2$date,
    _ref2$time = _ref2.time,
    time = _ref2$time === void 0 ? null : _ref2$time;
  var buttonsJSX = useMemo(function () {
    return buttons.map(function (button, idx) {
      button = Object.assign(Object.assign({}, button), {
        invert: false,
        action: !IS_DEKSTOP && isL2PTracker ? '/appointment/lead_tracker' : populateStringTemplate(button.action, {
          bookingId: bookingId
        })
      });
      return /*#__PURE__*/React.createElement(CTA, {
        key: "widget_".concat(name, "_cta_").concat(idx),
        button: button,
        customClass: css.button,
        widgetKey: name,
        track: track,
        locationId: locationId
      });
    });
  }, [buttons, IS_DEKSTOP, isL2PTracker, bookingId, name, track, locationId]);
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: css.bcWidget
  }, /*#__PURE__*/React.createElement("div", {
    className: css.topContent
  }, /*#__PURE__*/React.createElement("div", {
    className: css.imageWrapper
  }, /*#__PURE__*/React.createElement(ImageWrapper, {
    image: image,
    className: css.image
  })), /*#__PURE__*/React.createElement("div", {
    className: css.carDetails
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    size: "8"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: css.footnote
  }, /*#__PURE__*/React.createElement(Translation, {
    id: "carDetails"
  })), /*#__PURE__*/React.createElement("div", null, "".concat(make, " ").concat(model ? "".concat(model, ",") : '', " ").concat(year))))))), /*#__PURE__*/React.createElement("div", {
    className: css.textContent
  }, /*#__PURE__*/React.createElement("div", {
    className: css.centerDetails
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    size: "6"
  }, /*#__PURE__*/React.createElement("div", {
    className: css.flex
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "location",
    color: "primaryBase",
    size: 18
  }), /*#__PURE__*/React.createElement("span", {
    className: cx(css.footnote, css.marginLeft2)
  }, /*#__PURE__*/React.createElement(Translation, {
    id: "storeDetails"
  }))), /*#__PURE__*/React.createElement("div", {
    className: css.marginTop2
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(css.body1, css.ellipses)
  }, centerName))), /*#__PURE__*/React.createElement(Col, {
    size: "6"
  }, /*#__PURE__*/React.createElement("div", {
    className: css.flex
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "meeting",
    color: "primaryBase",
    size: 18
  }), /*#__PURE__*/React.createElement("span", {
    className: cx(css.body1, css.marginLeft2, css.ellipses)
  }, date)), /*#__PURE__*/React.createElement("div", {
    className: cx(css.flex, css.marginTop2)
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "clock",
    color: "primaryBase",
    size: 18
  }), /*#__PURE__*/React.createElement("span", {
    className: cx(css.body1, css.marginLeft2, css.ellipses)
  }, time))))), !!userIsLogged && /*#__PURE__*/React.createElement("div", {
    className: css.buttonWrapper
  }, buttonsJSX)));
};
export default withConfig(BookingConfirmedWidget);